const root = Function('return this')()

export default root